// extracted by mini-css-extract-plugin
export default {"page":"EnrichmentPage-module__page___c379l"};